import { COLORS } from '@btime/constants'
import { useFormState } from '@btime/react-hooks'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text, Title } from '../../../components/presentation/Text'
import { useSubdomain, useQueryParams } from '../../../utils/contexts/UrlProvider'
import Button from '../../../components/actions/Button'
import Input from '../../../components/form/Input'
import Separator from '../../../components/helpers/Separator'
import useCreatePassword from './_requests/createPassword'

const LoginForm = () => {
  const { t } = useTranslation(['session', 'common'])
  const workspace = useSubdomain()
  const { t: token, e: email } = useQueryParams()
  const [form, handleChange] = useFormState({
    newPassword: '',
    confirmPassword: '',
    email,
    token,
    workspace
  })

  const [onSubmit, { loading }] = useCreatePassword(form)

  return (
    <form onSubmit={onSubmit}>
      <Title size="h3">{t('newPasswordForm.resettingPassword')}</Title>

      <Separator weight={4} />

      <Input
        type="password"
        placeholder={t('session:password')}
        value={form.newPassword}
        onChange={handleChange('newPassword')}
      />
      <Separator weight={4} />

      <Input
        type="password"
        placeholder={t('newPasswordForm.confirmPassword')}
        value={form.confirmPassword}
        onChange={handleChange('confirmPassword')}
      />

      <Separator weight={4} />

      <Text color={COLORS.red}>
        {form.newPassword !== form.confirmPassword && t('newPasswordForm.passwordsDoNotMatch')}
      </Text>
      <Text color={COLORS.red}>
        {form.touched && (!form.newPassword || !form.confirmPassword)
          ? t('newPasswordForm.enterPasswordAndConfirmation')
          : ''}
      </Text>

      <Button type="submit" fullWidth loading={loading} color={COLORS.purple}>
        {t('newPasswordForm.changePassword')}
      </Button>
    </form>
  )
}

export default LoginForm
